import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Alert, Spin } from 'antd';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Sites from './pages/Sites';
import PushRecords from './pages/PushRecords';
import WeChatRecords from './pages/WeChatRecords';
import GroupConfig from './pages/GroupConfig';
import RobotSettings from './pages/RobotSettings';
import Users from './pages/Users';

import UserRobotBindings from './pages/UserRobotBindings';
import AIConfig from './pages/AIConfig';
import Profile from './pages/Profile';
import MailSettings from './pages/MailSettings';
import FailureAlertSettings from './pages/FailureAlertSettings';
import SubmissionSettings from './pages/SubmissionSettings';
import JobSourceSettings from './pages/JobSourceSettings';
import BackendConnectionSettings from './components/BackendConnectionSettings';

function LegacyRedirect({ to }) {
  const location = useLocation();
  return <Navigate to={to + location.search} replace />;
}
function LegacyIntegration() {
  const location = useLocation();
  return <Navigate to={new URLSearchParams(location.search).get('tab') === 'push' ? '/push-records/submission-settings' : '/settings/job-source'} replace />;
}
function AdminPage({ children }) {
  const { user } = useAuth();
  return user?.role === 'super_admin' ? children : <Alert type="warning" showIcon message="此页面需要超级管理员权限" />;
}

function App() {
  const { isAuthenticated, loading, token } = useAuth();

  // 仅当存在token且正在校验时，才显示全屏加载
  if (loading && token) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        flexDirection: 'column',
        gap: 24,
        height: '100vh' 
      }}>
        <Spin size="large" />
        <BackendConnectionSettings />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/sites" element={<Sites />} />
        <Route path="/push-records" element={<PushRecords />} />
        <Route path="/wechat-records" element={<WeChatRecords />} />
        <Route path="/wechat-records/groups" element={<GroupConfig />} />
        <Route path="/push-records/extraction-failures" element={<WeChatRecords extractionOnly />} />
        <Route path="/push-records/submission-settings" element={<SubmissionSettings />} />
        <Route path="/push-records/failure-alerts" element={<FailureAlertSettings />} />
        <Route path="/settings" element={<Navigate to="/settings/robots" replace />} />
        <Route path="/settings/robots" element={<AdminPage><RobotSettings /></AdminPage>} />
        <Route path="/settings/job-source" element={<AdminPage><JobSourceSettings /></AdminPage>} />
        <Route path="/settings/ai" element={<AdminPage><AIConfig /></AdminPage>} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/robot-access" element={<AdminPage><UserRobotBindings /></AdminPage>} />
        <Route path="/group-config" element={<LegacyRedirect to="/wechat-records/groups" />} />
        <Route path="/robot-settings" element={<LegacyRedirect to="/settings/robots" />} />
        <Route path="/user-robot-bindings" element={<LegacyRedirect to="/users/robot-access" />} />
        <Route path="/ai-config" element={<LegacyRedirect to="/settings/ai" />} />
        <Route path="/settings/integrations" element={<LegacyIntegration />} />
        <Route path="/settings/mail" element={<MailSettings />} />
        <Route path="/job-source" element={<LegacyRedirect to="/settings/job-source" />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/login" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
